import axios from "./request"

export default {
  async get(integrationType) {
    return (await axios.get('/plans', {
      params: { type: integrationType }
    })).data
  }
}
